<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="调货单">
      <template v-if="hasPermission('采购-调货单-新增')">
        <el-button
          size="small"
          icon="el-icon-plus"
          type="primary"
          @click="newlyAdded"
          >新增调货单</el-button
        >
      </template>
    </pageTitle>
    <basicList
      :config="basicListconfig"
      @sortChange="sortChange"
      @search="searchEvent"
    >
      <template v-slot:status="row">
        <template v-if="row.row.status == 1">
          {{ row.row.status == 2 ? "撤销" : "已完成" }}
        </template>
        <el-link v-else type="danger">
          {{
            row.row.status == 0
              ? "待入库"
              : row.row.status == 3
              ? "待出库"
              : row.row.status == 4
              ? "待审核"
              : "--"
          }}
        </el-link>
      </template>
      <template v-slot:operation="row">
        <div style="display: flex; align-items: center">
          <el-popover
            :visible-arrow="false"
            placement="bottom"
            width="80"
            trigger="click"
          >
            <ul class="moreOperations">
              <!-- 待审核状态 -->
              <template v-if="row.row.status == 4">
                <li
                  v-if="
                    hasPermission('采购-调货单-编辑') &&
                    user_can_edit_shop_list.includes(row.row.out_shop_id)
                  "
                  @click="approved(row.row)"
                >
                  <i class="iconfont icon-shenhe"></i> 审核
                </li>

                <li
                  v-if="
                    hasPermission('采购-调货单-编辑') &&
                    user_can_edit_shop_list.includes(row.row.in_shop_id)
                  "
                  @click="edit(row.row)"
                >
                  <i class="iconfont icon-shenhe"></i> 编辑
                </li>

                <li
                  v-if="
                    hasPermission('采购-调货单-编辑') &&
                    (user_can_edit_shop_list.includes(row.row.out_shop_id) ||
                      user_can_edit_shop_list.includes(row.row.in_shop_id))
                  "
                  @click="cancelOrder(row.row)"
                >
                  <i class="iconfont icon-quxiao"></i> 撤销
                  <!-- </div> -->
                </li>
              </template>

              <!-- 待出库状态 -->
              <template v-if="row.row.status == 3">
                <li
                  v-if="
                    hasPermission('采购-调货单-编辑') &&
                    user_can_edit_shop_list.includes(row.row.out_shop_id)
                  "
                  @click="shipment(row.row)"
                >
                  <i class="iconfont icon-querendingdan"></i> 出库
                </li>

                <li
                  v-if="
                    hasPermission('采购-调货单-编辑') &&
                    (user_can_edit_shop_list.includes(row.row.out_shop_id) ||
                      user_can_edit_shop_list.includes(row.row.in_shop_id))
                  "
                  @click="cancelOrder(row.row)"
                >
                  <i class="iconfont icon-quxiao"></i> 撤销
                </li>
              </template>

              <!-- 待入库状态 -->
              <template v-if="row.row.status == 0">
                <li
                  v-if="
                    hasPermission('采购-调货单-编辑') &&
                    user_can_edit_shop_list.includes(row.row.in_shop_id)
                  "
                  @click="delivery(row.row)"
                >
                  <i class="iconfont icon-querendingdan"></i> 入库
                </li>

                <li
                  v-if="
                    hasPermission('采购-调货单-编辑') &&
                    (user_can_edit_shop_list.includes(row.row.out_shop_id) ||
                      user_can_edit_shop_list.includes(row.row.in_shop_id))
                  "
                  @click="cancelOrder(row.row)"
                >
                  <i class="iconfont icon-quxiao"></i> 撤销
                </li>
              </template>

              <!-- 已完成状态 -->
              <template v-if="row.row.status == 1">
                <li
                  v-if="true || hasPermission('采购-调货单-查看')"
                  @click="preview(row.row)"
                >
                  <i class="iconfont icon-dayin"></i> 查看
                </li>

                <li
                  v-if="
                    hasPermission('采购-调货单-删除') && row.row.status!=1 &&
                    (user_can_delete_shop_list.includes(row.row.out_shop_id) ||
                      user_can_delete_shop_list.includes(row.row.in_shop_id))
                  "
                  @click="del(row.row)"
                >
                  <i class="iconfont icon-dayin"></i> 删除
                </li>
              </template>

              <!-- 取消状态 -->
              <template v-if="row.row.status == 2">
                <li
                  v-if="
                    hasPermission('采购-调货单-编辑') &&
                    (user_can_edit_shop_list.includes(row.row.out_shop_id) ||
                      user_can_edit_shop_list.includes(row.row.in_shop_id))
                  "
                  @click="edit(row.row)"
                >
                  <i class="iconfont icon-dayin"></i> 编辑
                </li>

                <li
                  v-if="
                    hasPermission('采购-调货单-删除') &&
                    (user_can_delete_shop_list.includes(row.row.out_shop_id) ||
                      user_can_delete_shop_list.includes(row.row.in_shop_id))
                  "
                  @click="del(row.row)"
                >
                  <i class="iconfont icon-dayin"></i> 删除
                </li>
              </template>
              <li @click="freight(row.row)">
                <i class="iconfont icon-dayin"></i> 运费
              </li>
              <li @click="confirmPrinting(row.row)">
                <i class="iconfont icon-dayin"></i> 打印
              </li>
            </ul>
            <div slot="reference" class="button button_more">
              <img src="../../assets/images/icon_more.png" />
            </div>
          </el-popover>
        </div>
      </template>
    </basicList>
    <formWindow
      v-if="dialogParams.visible"
      :dialogParams="dialogParams"
      @close="closeThePopUpWindow"
    ></formWindow>
    <previewComponents
      @close="closeView"
      :acceptedParameters="previewParams"
    ></previewComponents>
    <Freigth :config="freightConfig" @close="closefreightConfig"></Freigth>
    <!-- 打印组件 -->
    <printingComponents
      @close="closePrinting"
      :acceptedParameters="printingParameter"
      @refresh="refreshPrinting"
    ></printingComponents>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  orderMoveGetlist,
  orderMoveCancel,
  orderMoveDel,
  orderMoveDetail,
  getShopStocks,
} from "@/api/purchasing";
import {
  getshoplist,
  supplierGetList,
  userPermissionShopGetList,
  userPermissionSupplierGetList,
} from "@/api/basicConfiguration";
import { getRoles } from "@/utils";
// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
export default {
  name: "goodsTransferManagement",
  components: {
    formWindow: () => import("./formWindow.vue"),
    previewComponents: () => import("@/components/previewComponents"),
    Freigth: () => import("../salesManagement/freigth.vue"),
    printingComponents: () => import("@/components/printingComponents"),
  },
  data() {
    return {
      compId: null,
      userId: null,
      roleId: null,
      shopId: null,
      shopIds: [], // 所有店铺
      user_can_edit_shop_list: [], // 权限管理中允许用户使用的店铺，高级角色看所有店铺
      user_can_delete_shop_list: [], // 权限管理中允许用户使用的店铺，高级角色看所有店铺
      // 弹窗参数
      dialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
        type: "",
      },
      // 列表组件参数
      basicListconfig: {
        loading: false,
        operationWidth: 80,
        search: [
          {
            label: "入库门店",
            type: "select",
            options: [],
            key: "in_shop_id",
            value: "",
          },
          {
            label: "出库门店",
            type: "select",
            options: [],
            key: "out_shop_id",
          },
          {
            label: "状态",
            type: "select",
            options: [
              {
                label: "待入库",
                value: 0,
              },
              {
                label: "已完成",
                value: 1,
              },
              {
                label: "撤销",
                value: 2,
              },
              {
                label: "待出库",
                value: 3,
              },
              {
                label: "待审核",
                value: 4,
              },
            ],
            key: "status",
          },
          {
            label: "日期",
            type: "daterange",
            key: "create_time",
          },
          {
            label: "关键词",
            type: "input",
            key: "form_sn",
          },
        ],
        data: [],
        column: [
          {
            label: "编号",
            prop: "id",
            sortable: true,
            width: 100,
          },
          {
            label: "更新时间",
            prop: "update_time",
            sortable: true,
            width: 180,
          },
          {
            label: "状态",
            prop: "status",
            // filter: "adjustmentStatus",
            slot: true,
            width: 100,
          },
          {
            label: "入库门店",
            prop: "in_shop_name",
            width: 150,
          },
          {
            label: "出库门店",
            prop: "out_shop_name",
            width: 150,
          },
          {
            label: "数量",
            prop: "num",
            sortable: true,
            width: 120,
          },
          {
            label: "调货金额",
            prop: "item_money",
            sortable: true,
            isMoney: true,
            width: 120,
          },
          {
            label: "运费",
            prop: "trans_money",
            sortable: true,
            isMoney: true,
            width: 120,
          },
          {
            label: "申请人",
            prop: "user_name",
            width: 120,
          },
          {
            label: "出库人",
            prop: "out_user_name",
            width: 120,
          },
          {
            label: "入库人",
            prop: "in_user_name",
            width: 120,
          },
          {
            label: "备注",
            prop: "remark",
            width: 200,
          },
          {
            label: "开单时间",
            prop: "create_time",
            sortable: true,
            width: 180,
          },
          {
            label: "调货单号",
            prop: "form_sn",
            width: 250,
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      previewParams: {
        key: new Date().getTime(),
        visible: false,
        type: "purchaseOrder",
        code: "",
        viewObj: [],
      },
      freightConfig: {
        visible: false,
        key: new Date().getTime(),
        data: {
          shop_id: "",
          money: "",
          id: "",
          part_id: "",
          from_sn: "",
          comp_id: "",
        },
      },
      printingParameter: {
        key: new Date().getTime(),
        visible: false,
        type: "saleOrder",
        viewObj: [],
        code: "",
      },
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    this.roleId = this.$store.getters.userInfo.roleId;
    this.shopId = this.$store.getters.userInfo.shopId;
    // 初始化列表内容
    // this.getlist();
    this.obtainDataSource().then(() => {
      this.getlist(); // 先拿基础数据，在拉记录
    });
  },
  computed: {
    ...mapGetters(["hasPermission", "getPermissionId"]),
  },
  methods: {
    closePrinting() {
      this.printingParameter.key = new Date().getTime();
      this.printingParameter.visible = false;
    },
    refreshPrinting() {
      this.preview(this.temporaryRowData, "printingParameter");
    },
    confirmPrinting(row) {
      this.printingParameter.code = row.form_sn;
      this.printingParameter.documentName = "调货单号";
      orderMoveDetail({
        id: row.id,
        comp_id: JSON.parse(getRoles()).comp_id,
      }).then((res) => {
        if (res.code == 1) {
          let order_info = res.data[0];
          let item_ids = [];
          let data = res.data[0].order_list.map((item) => {
            item_ids.push(item.item_id);
            item.name =
              item.item_info.name + "(1*" + item.item_info.in_package_num + ")";
            item.type_spec = item.item_info.type_spec;
            item.item_info.value = item.item_id;
            item.avg_price = this.$money(item.avg_price);
            item.total_money = this.$money(item.total_money);
            delete item.item_info.item_stock_package;
            item.inventoryBox = item.item_stock_package_out;
            delete item.item_info.item_stock_single;
            item.inventoryDispersion = item.item_stock_single_out;
            item.in_package_num = item.item_info.in_package_num;
            item.num = item.num;
            item.freezeInventory = item.freeze_num;
            item.totalInventory =
              Number(item.inventoryDispersion) +
              Number(item.inventoryBox) * Number(item.in_package_num);
            item.totalPurchaseQuantity =
              Number(item.item_stock_single) +
              Number(item.item_stock_package) * Number(item.in_package_num);
            item.productOptions = [item.item_info];
            return item;
          });

          this.printingParameter.viewObj = [
            {
              title: "",
              type: "object",
              value: [
                {
                  label: "调出门店",
                  value: order_info.out_shop_name,
                },
                {
                  label: "调入门店",
                  value: order_info.in_shop_name,
                },
                {
                  label: "制单人",
                  value: order_info.user_name,
                },
                {
                  label: "出库人",
                  value: order_info.out_user_name,
                },
                {
                  label: "入库人",
                  value: order_info.in_user_name,
                },
                {
                  label: "调货日期",
                  value: order_info.create_time,
                },
                {
                  label: "备注",
                  value: order_info.remark,
                },
              ],
            },
            {
              title: "",
              type: "array",
              value: data,
              column: [
                {
                  label: "商品名称",
                  prop: "name",
                },
                {
                  label: "单位",
                  prop: "type_spec",
                },
                {
                  label: "单价",
                  prop: "avg_price",
                },
                {
                  label: "数量",
                  prop: "totalPurchaseQuantity",
                },
                {
                  label: "小计",
                  prop: "total_money",
                },
              ],
            },
            {
              title: "",
              type: "object",
              value: [
                {
                  label: "商品金额",
                  value: this.$money(order_info.item_money),
                },
                {
                  label: "运费金额",
                  value: this.$money(order_info.trans_money),
                },
              ],
            },
          ];

          this.printingParameter.key = new Date().getTime();
          this.printingParameter.visible = true;
        } else {
          this.$message.error("获取详情失败");
        }
      });
    },
    closefreightConfig() {
      this.freightConfig.visible = false;
      this.freightConfig.key = new Date().getTime();
      this.getlist();
    },
    freight(row) {
      this.freightConfig.key = new Date().getTime();
      this.freightConfig.visible = true;
      this.freightConfig.data.money = this.$money(row.trans_money);
      this.freightConfig.data.from_sn = row.form_sn;
      this.freightConfig.data.shop_id = row.shop_id;
      this.freightConfig.data.user_id = JSON.parse(getRoles()).user_id;
      this.freightConfig.data.customer_id = row.customer_id;
      this.freightConfig.data.supplier_id = 0;
      this.freightConfig.data.part_id = JSON.parse(getRoles()).part_id;
      this.freightConfig.data.id = "";
      this.freightConfig.data.comp_id = row.comp_id;
      // this.freightConfig.type = "seasoningCondiments";
      this.freightConfig.data.type = this.freightConfig.type = "out";
    },
    sortChange(data) {
      this.basicListconfig.searchParameters.page = 1;
      this.basicListconfig.searchParameters.order_column = data.prop;
      this.basicListconfig.searchParameters.order_up =
        data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getlist();
    },
    closeView() {
      this.previewParams.key = new Date().getTime();
      this.previewParams.visible = false;
    },
    // 查看事件
    preview(row) {
      this.previewParams.code = row.form_sn;
      orderMoveDetail({
        id: row.id,
        comp_id: JSON.parse(getRoles()).comp_id,
      }).then((res) => {
        if (res.code == 1) {
          let order_info = res.data[0];
          let item_ids = [];
          let data = res.data[0].order_list.map((item) => {
            item_ids.push(item.item_id);
            item.name =
              item.item_info.name +
              "(1*" +
              item.item_info.in_package_num +
              ")(" +
              item.item_info.item_number +
              ")";
            item.item_info.value = item.item_id;
            item.avg_price = this.$money(item.avg_price);
            item.total_money = this.$money(item.total_money);
            delete item.item_info.item_stock_package;
            item.inventoryBox = item.item_stock_package_out;
            delete item.item_info.item_stock_single;
            item.inventoryDispersion = item.item_stock_single_out;
            item.in_package_num = item.item_info.in_package_num;
            item.num = item.num;
            item.freezeInventory = item.freeze_num;
            item.totalInventory =
              Number(item.inventoryDispersion) +
              Number(item.inventoryBox) * Number(item.in_package_num);
            item.totalPurchaseQuantity =
              Number(item.item_stock_single) +
              Number(item.item_stock_package) * Number(item.in_package_num);
            item.productOptions = [item.item_info];
            return item;
          });
          getShopStocks({
            comp_id: JSON.parse(getRoles()).comp_id,
            shop_id: order_info.in_shop_id,
            item_id: item_ids.join(","),
          }).then((res) => {
            if (res.code == 1) {
              res.data.forEach((in_shop_item) => {
                for (let i = 0; i < data.length; i++) {
                  let item = data[i];
                  if (item.item_id == in_shop_item.item_id) {
                    this.$set(data[i], "totalInventory_in", in_shop_item.num);
                    this.$set(
                      data[i],
                      "inventoryBox_in",
                      in_shop_item.item_stock_package
                    );
                    this.$set(
                      data[i],
                      "inventoryDispersion_in",
                      in_shop_item.item_stock_single
                    );
                  }
                }
              });
            } else {
              this.$message.error(res.data.msg || "获取该产品调入门店库存失败");
            }
          });

          this.previewParams.viewObj = [
            {
              title: "",
              type: "object",
              value: [
                {
                  label: "调出门店",
                  value: order_info.out_shop_name,
                },
                {
                  label: "调入门店",
                  value: order_info.in_shop_name,
                },
                {
                  label: "制单人",
                  value: order_info.user_name,
                },
                {
                  label: "出库人",
                  value: order_info.out_user_name,
                },
                {
                  label: "入库人",
                  value: order_info.in_user_name,
                },
                {
                  label: "备注",
                  value: order_info.remark,
                },
              ],
            },
            {
              title: "调货明细",
              type: "array",
              value: data,
              column: [
                {
                  label: "商品名称",
                  prop: "name",
                },
                // {
                //   label: "调出店库存",
                //   prop: "totalInventory",
                //   width: 120,
                //   align: "center",

                // },
                // {
                //   label: "调入店库存",
                //   prop: "totalInventory_in",
                //   width: 120,
                //   align: "center",

                // },
                {
                  label: "成本价",
                  prop: "avg_price",
                  width: 100,
                },
                {
                  label: "数量",
                  prop: "totalPurchaseQuantity",
                  width: 120,
                  align: "center",
                  // children: [
                  //   {
                  //     label: "散",
                  //     prop: "item_stock_single",
                  //     width: 90,
                  //     align: "center",
                  //   },
                  //   {
                  //     label: "箱",
                  //     prop: "item_stock_package",
                  //     width: 90,
                  //     align: "center",
                  //   },
                  //   {
                  //     label: "总",
                  //     prop: "totalPurchaseQuantity",
                  //     width: 90,
                  //     align: "center",
                  //   },
                  // ],
                },
                {
                  label: "小计",
                  prop: "total_money",
                  width: 100,
                },
              ],
            },
            {
              title: "调货金额",
              type: "object",
              value: [
                {
                  label: "商品金额",
                  value: this.$money(order_info.item_money),
                },
                {
                  label: "运费金额",
                  value: this.$money(order_info.trans_money),
                },
                {
                  label: "调货总金额",
                  value: this.$money(order_info.total_money),
                },
              ],
            },
          ];

          this.previewParams.key = new Date().getTime();
          this.previewParams.visible = true;
        } else {
          this.$message.error("获取详情失败");
        }
      });
    },
    cancelOrder(row) {
      this.$confirm("撤销当前调货单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        orderMoveCancel({
          id: row.id,
          comp_id: JSON.parse(getRoles()).comp_id,
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("撤销成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg || "撤销失败！");
          }
        });
      });
    },
    del(row) {
      this.$confirm("删除当前调货单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        orderMoveDel({
          id: row.id,
          comp_id: JSON.parse(getRoles()).comp_id,
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.getlist();
          } else {
            this.$message.error(res.msg || "删除失败！");
          }
        });
      });
    },
    // 关闭弹窗
    closeThePopUpWindow() {
      this.dialogParams.visible = false;
      this.dialogParams.key = new Date().getTime();
      this.getlist();
    },

    // 显示
    show(row) {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.id;
      this.dialogParams.type = "show";
    },
    // 编辑
    edit(row) {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.id;
      this.dialogParams.type = "edit";
    },
    // 审核
    approved(row) {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.id;
      this.dialogParams.type = "approved";
    },
    // 入库
    delivery(row) {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.id;
      this.dialogParams.type = "delivery";
    },
    // 出库
    shipment(row) {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.id;
      this.dialogParams.type = "shipment";
    },
    // 开单
    newlyAdded() {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = "";
      this.dialogParams.type = "create";
    },

    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          if (Array.isArray(data[key])) {
            if (data[key].length == 0) {
              delete this.basicListconfig.searchParameters.begin_time;
              delete this.basicListconfig.searchParameters.end_time;
            } else {
              this.basicListconfig.searchParameters.begin_time = data[key][0];
              this.basicListconfig.searchParameters.end_time = data[key][1];
            }
          }
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;

      // 有用户门店权限的，查看只能看指定门店记录
      // 用户选中店铺时，按所选店铺查看; 未选时，按用户权限所有店面查询
      // if (!this.basicListconfig.searchParameters["shop_id"]) {
      //   if (this.shopIds.length != 0) {
      //     this.basicListconfig.searchParameters["shop_id"] =
      //       this.shopIds.join(", ");
      //   }
      // }
      this.basicListconfig.searchParameters.comp_id = JSON.parse(
        getRoles()
      ).comp_id;
      orderMoveGetlist(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data;
          this.basicListconfig.total = res.count;
        } else if (res.code == 0) {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
    // 获取门店\供应商\资金账户 受权限控制
    getSupplier() {
      if (this.roleId == 4) {
        return userPermissionSupplierGetList({
          limit: 10000,
          status: 1,
          comp_id: this.compId,
        }).then((res) => {
          if (res.code == 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key == "supplier_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.id + "-" + item.nick_name,
                    value: item.id,
                  };
                });
              }
            });
          } else if (res.code == 0) {
            this.$message.error(res.data.msg || "获取供应商数据源失败！");
          }
        });
      } else {
        return supplierGetList({
          limit: 10000,
          status: 1,
          comp_id: this.compId,
        }).then((res) => {
          if (res.code == 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key == "supplier_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.id + "-" + item.nick_name,
                    value: item.id,
                  };
                });
              }
            });
          } else if (res.code == 0) {
            this.$message.error(res.data.msg || "获取供应商数据源失败！");
          }
        });
      }
    },
    getShops() {
      // 调货单放开所有店铺权限
      return getshoplist({ limit: 10000, status: 0, with_joinshop: 1 })
        .then((res) => {
          if (res.code == 1) {
            this.shopIds = res.data.map((item) => item.id);
            this.basicListconfig.search.map((item) => {
              if (item.key == "in_shop_id" || item.key == "out_shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: Number(item.id),
                  };
                });
              }
            });
            return true;
          } else if (res.code == 0) {
            this.$message.error(res.data.msg || "获取门店数据源失败！");
            throw false;
          }
        })
        .then((res, rej) => {
          if (this.roleId == 4) {
            // 用户可执行编辑任务门店
            this.user_can_edit_shop_list = [];

            getshoplist({
              comp_id: this.compId,
              is_showAll: 1,
              // user_id: this.userId,
              // permission_id: this.getPermissionId("采购-调货单-编辑"),
            }).then((res) => {
              if (res.code == 1) {
                this.user_can_edit_shop_list = res.data.map((item) => item.id);
              } else {
                this.$message.error(
                  res.data.msg || "获取用户可操作门店数据失败！"
                );
              }
            });

            // 用户可执行删除任务门店
            this.user_can_delete_shop_list = [];
            userPermissionShopGetList({
              comp_id: this.compId,
              user_id: this.userId,
              permission_id: this.getPermissionId("采购-调货单-删除"),
            }).then((res) => {
              if (res.code == 1) {
                this.user_can_delete_shop_list = res.data.map(
                  (item) => item.id
                );
              } else {
                this.$message.error(
                  res.data.msg || "获取用户可操作门店数据失败！"
                );
              }
            });
          } else {
            this.user_can_edit_shop_list = this.shopIds;
            this.user_can_delete_shop_list = this.shopIds;
          }
        }, {});
    },

    // 获取基础数据，获取完后才能拿列表
    obtainDataSource() {
      return Promise.all([this.getShops(), this.getSupplier()]);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/goodsTransferManagement/index.vue